__turbopack_context__.v({
  "card": "styles-module-scss-module__UBnjeq__card",
  "card_bottom": "styles-module-scss-module__UBnjeq__card_bottom",
  "card_is_media": "styles-module-scss-module__UBnjeq__card_is_media",
  "card_is_small": "styles-module-scss-module__UBnjeq__card_is_small",
  "card_top": "styles-module-scss-module__UBnjeq__card_top",
  "on_market_date": "styles-module-scss-module__UBnjeq__on_market_date",
  "pending_alert": "styles-module-scss-module__UBnjeq__pending_alert",
  "property_address": "styles-module-scss-module__UBnjeq__property_address",
  "property_details": "styles-module-scss-module__UBnjeq__property_details",
  "property_details_container": "styles-module-scss-module__UBnjeq__property_details_container",
  "property_image": "styles-module-scss-module__UBnjeq__property_image",
  "property_price": "styles-module-scss-module__UBnjeq__property_price",
  "property_realtor_container": "styles-module-scss-module__UBnjeq__property_realtor_container",
  "property_realtors": "styles-module-scss-module__UBnjeq__property_realtors",
  "property_status": "styles-module-scss-module__UBnjeq__property_status",
  "property_status_sold": "styles-module-scss-module__UBnjeq__property_status_sold",
});
